import {
  Route,
  Routes as ReactRoutes
} from 'react-router-dom';
import React from 'react';
import loadable from '@loadable/component';
import * as Sentry from '@sentry/react';
import { URLS } from 'Douleutaras/constants/urls';
// import ProProfile from '../views/pro-profile/components/ProProfile';

const PostJobIframe = loadable(() => import(/* webpackPrefetch: true */'../views/job/iframe/PostJobIframe'));
const JobDone = loadable(() => import(/* webpackPrefetch: true */'../views/job/jobdone/JobDone'));
const PostJobWebview = loadable(() => import(/* webpackPrefetch: true */'../views/job/webview/PostJobWebview'));
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(ReactRoutes);
const ClientDashboard = loadable(() => import(/* webpackPrefetch: true */'../views/client-dashboard'));
const ProDashboard = loadable(() => import(/* webpackPrefetch: true */'../views/seller-dashboard'));
const ProProfile = loadable(() => import(/* webpackPrefetch: true */'../views/pro-profile/components/ProProfile'));
const AutoLogin = loadable(() => import(/* webpackPrefetch: true */'../views/auth-view/AutoLogin/AutoLogin')
  .then(component => component.AutoLogin));
const AuthView = loadable(() => import(/* webpackPrefetch: true */'../views/auth-view/AuthView/AuthView'));
const ContactUsPage = loadable(() => import(/* webpackPrefetch: true */'../views/contact-us'));
const ReviewProPublic = loadable(() => import(/* webpackPrefetch: true */'../views/review-pro-public'));
const NotFound = loadable(() => import(/* webpackPrefetch: true */'../layout/service-pages/NotFound')
  .then(component => component.NotFoundWrapped));

const Test = loadable(() => import(/* webpackPrefetch: true */'../views/Test'));

const Routes = () => (
  <SentryRoutes>
    <Route path="/dashboard-v2/test" element={<Test />} />
    <Route path={URLS.JOB_DONE} element={<JobDone />} />
    {/*Public routes*/}
    <Route path={URLS.AUTHENTICATION.IFRAME} element={<AuthView />} />
    <Route path={URLS.AUTHENTICATION.LOGIN} element={<AuthView />} />

    {/* /accounts/redirect/L2Rhc2hib2FyZC12Mi9qb2IvMjU5OTg0MC8/0 */}
    {/* L2Rhc2hib2FyZC12Mi9qb2IvMjU5OTg0MC8 - encrypted redirect route */}
    {/* 0 - token is valid */}
    {/* 1 - token is invalid */}
    <Route path={URLS.AUTHENTICATION.REDIRECT} element={<AutoLogin />}/>
    <Route path={URLS.CONTACT_US.INDEX} element={<ContactUsPage />} />
    <Route path={URLS.POST_JOB.WEBVIEW} element={<PostJobWebview />} />
    <Route path={URLS.POST_JOB.IFRAME} element={<PostJobIframe />} />

    {/* /r/gianniseuaggelopoulos_ZQEI */}
    {/* gianniseuaggelopoulos - username */}
    <Route path={URLS.PUBLIC_REVIEW} element={<ReviewProPublic />}></Route>
    {/* End of public routes*/}

    <Route path={`${URLS.PRO_PROFILE.INDEX}/*`} element={<ProProfile />} />
    <Route path={`${URLS.PRO_DASHBOARD.INDEX}/*`} element={<ProDashboard />} />
    <Route path={`${URLS.CLIENT_DASHBOARD.INDEX}/*`} element={<ClientDashboard />} />

    <Route path="*" element={<NotFound />} />
  </SentryRoutes>
);

export default Routes;
